// Tracks the ActionCable connection for a channel: shows the #cable-status banner while the socket
// is down and refreshes once when it comes back, since broadcasts sent in between were missed.
// There is no HTTP poll while the socket is down: a Turbo visit that fails on a network error makes
// Turbo do a full reload, which lands on the browser error page when the server is unreachable.
// The ActionCable consumer reconnects by itself (3-30 s backoff, and on visibilitychange).
export default function connectionStatus(refresh) {
  let downSince = null

  const render = () => {
    const banner = document.getElementById('cable-status')
    if (!banner) return

    banner.hidden = !downSince
    if (downSince) {
      banner.textContent = `Няма връзка със сървъра от ${downSince.toTimeString().split(' ')[0]}. Резултатите може да не са актуални.`
    }
  }

  document.addEventListener('turbo:load', render)

  return {
    connected() {
      if (downSince) {
        downSince = null
        refresh()
      }
      render()
    },

    disconnected() {
      if (!downSince) downSince = new Date()
      render()
    }
  }
}
